module.exports = __webpack_public_path__ + "static/img/Enhanced-Lead-Capture-Widget@2x.03e9455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module/img/widget/Enhanced-Lead-Capture-Widget@2x.png
// module id = fV+r
// module chunks = 1